import renderItemNode from './renderitemnode.js';
import triggerOne from '../../trigger/_triggerone.js';
import checkAlreadyRendered from './checkalreadyrendered.js';
import forEach from '../../_helpers/foreach.js';
// this function renders inserted items if possible when push method is called
export default function processPush(_ref) {
  var self = _ref.self,
    selfDef = _ref.selfDef,
    eventOptions = _ref.eventOptions,
    container = _ref.container;
  var added = eventOptions.added,
    silent = eventOptions.silent;
  forEach(added, function (item) {
    if (item && typeof item === 'object') {
      // if a node of an item is already rendered then throw an error
      checkAlreadyRendered({
        item: item,
        selfDef: selfDef
      });
      // render
      var _renderItemNode = renderItemNode({
          selfDef: selfDef,
          self: self,
          item: item,
          eventOptions: eventOptions
        }),
        node = _renderItemNode.node,
        itemEventOptions = _renderItemNode.itemEventOptions;
      if (node) {
        container.appendChild(node);
        if (!silent) {
          triggerOne(item, 'afterrender', itemEventOptions);
        }
      }
    }
  });
}